import React from 'react'
import { useTranslation } from 'react-i18next'
import IconClose from '../../assets/icons/IconClose'
import { clsx } from '../../utils/helper'
import WrapIcon from '../elements/WrapIcon'

const GroupOrderHeader = ({
    groupCount,
    groupId,
    handleSelectGroup,
    handleDelGroup,
    isActive,
    viewOnly,
    removeAble = true,
}) => {
    const { t } = useTranslation()

    const handleClickDelGroup = e => {
        e.preventDefault()
        e.stopPropagation()
        handleDelGroup(groupId)
    }

    return (
        <div
            className={clsx(['group-order-separate', isActive && 'active'])}
            onClick={() => !viewOnly && handleSelectGroup(groupId)}
        >
            <div>{t('cartMobile.lbGroupOrder', { group: groupCount })}</div>
            {!viewOnly && removeAble && (
                <div onClick={handleClickDelGroup}>
                    <WrapIcon icon={IconClose} size="12px" color="000000" />
                </div>
            )}
        </div>
    )
}

export default GroupOrderHeader
